var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-p-c-list',{attrs:{"getParams":_vm.getParams,"id":"VpcListForCloudregionSidePage","hidden-actions":['create'],"hidden-filter-options":['brand', 'region', 'cloudaccount']}})}
var staticRenderFns = []

export { render, staticRenderFns }